import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useDropdown, DropdownContext } from '../../contexts/Dropdown';
import DropdownHeader from './DropdownHeader';
import DropdownItem from './DropdownItem';
import DropdownMenu from './DropdownMenu';
import DropdownToggle from './DropdownToggle';
/**
 * This should be extended to accept any positioning options as props e.g. `placement`, `strategy`, `middleware`,
 * https://floating-ui.com/docs/react#positioning
 *
 */
export const Dropdown = ({ children, ...restOptions }) => {
    const dropdown = useDropdown(restOptions);
    return _jsx(DropdownContext.Provider, { value: dropdown, children: children });
};
Dropdown.displayName = 'Dropdown';
export default Object.assign(Dropdown, {
    Toggle: DropdownToggle,
    Menu: DropdownMenu,
    Item: DropdownItem,
    Header: DropdownHeader,
});
